import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import MonetizationPromoIcon from '@wix/da-ds/pkg/Icons/species/MonetizationPromo';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './MonetizationPromoStrip.scss';
export const MonetizationPromoStrip = ({ monetizationPromo, className })=>{
    const { t } = useTranslation();
    const redesigned_money_banners = useFlag('redesigned_money_banners');
    if (![
        'tier',
        'commission',
        'premium_gallery',
        'adoptable',
        'pcp'
    ].includes(monetizationPromo)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.DARK
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], redesigned_money_banners && s['redesigned'], className)
    }, redesigned_money_banners ? /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, /*#__PURE__*/ React.createElement(MonetizationPromoIcon, {
        promoType: monetizationPromo,
        size: IconSize.MEDIUM,
        className: s['badge'],
        disableDefaultColors: true
    }), t(`avatar.monetizationPromoStrip.updated.var.${monetizationPromo}.body`)) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PromoBadge, {
        badgeType: monetizationPromo,
        size: 24,
        className: s['badge']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, t(`avatar.monetizationPromoStrip.var.${monetizationPromo}.body`)))));
};
MonetizationPromoStrip.displayName = 'MonetizationPromoStrip';
export default MonetizationPromoStrip;
